import Alert from 'common/components/alert/Alert';
import ActionStatus from 'common/types/ActionStatus';
import AlertType from 'common/types/AlertType';
import React from 'react';

interface IResidenceStatus {
  status: string;
  uploadStatus: ActionStatus;
  uploadMessage: string;
  hasAttachment: boolean;
  showValidation: boolean;
  error?: string;
}

const ResidenceStatus = (props: IResidenceStatus) => {
  if (!props.hasAttachment && props.showValidation) {
    return (
      <Alert type={AlertType.danger}>
        Please upload proof of residence document.
      </Alert>
    );
  }
  if (props.error && props.showValidation) {
    return <Alert type={AlertType.danger}>{props.error}</Alert>;
  }
  if (props.uploadStatus === ActionStatus.failed) {
    return (
      <Alert type={AlertType.danger}>
        The residence documents were not uploaded. {props.uploadMessage}
      </Alert>
    );
  } else if (props.uploadStatus === ActionStatus.saved) {
    return <Alert type={AlertType.success}>{props.uploadMessage}</Alert>;
  }

  if (props.status === 'APPROVED') {
    return (
      <Alert type={AlertType.success}>
        Primary residence documents have been approved.
      </Alert>
    );
  }
  if (props.status === 'REJECTED') {
    return (
      <Alert type={AlertType.danger}>
        Primary residence document(s) have been rejected. Please correct and
        re-upload.
      </Alert>
    );
  }
  if (props.status === 'PENDING' && props.hasAttachment) {
    return (
      <Alert type={AlertType.info}>
        Primary residence documents have been uploaded.
      </Alert>
    );
  }
  return null;
};

export default ResidenceStatus;
